/** Hub account fields used to decide if a disconnect-review row should merge. */
export type DisconnectReviewMergeAccount = {
  hubPublished?: boolean;
  disconnectDetected?: boolean;
  disconnectStatus?: string | null;
};

/**
 * Assessments list API (`compute_hub_disconnect_metrics`) is authoritative for
 * whether a level gap still exists. Disconnect-review is refreshed in parallel
 * but can lag; never treat a review row alone as an active disconnect.
 */
export const shouldMergeDisconnectReviewRow = (
  account: DisconnectReviewMergeAccount
): boolean => {
  if (account.hubPublished) return false;
  if (account.disconnectDetected) return true;
  const status = (account.disconnectStatus ?? "none").toLowerCase();
  return status !== "none" && status !== "published";
};
